import "./../../bindings/bao-tabs";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import SearchPaging from "./../../factories/search-paging";
import BaoDialog from "./../../factories/bao-dialog";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
function ShiftGroupViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(ShiftGroupViewModel, SearchPaging);
ShiftGroupViewModel.prototype.PrimaryKey = "ShiftGroupId";
ShiftGroupViewModel.prototype.RefreshUrl = "ShiftGroup/Get";
ShiftGroupViewModel.prototype.SaveUrl = "ShiftGroup/Save";
ShiftGroupViewModel.prototype.DeleteUrl = "ShiftGroup/Delete";
ShiftGroupViewModel.prototype.IsInUseUrl = "ShiftGroup/IsInUse";
ShiftGroupViewModel.prototype.PermissionForward = "ShiftGroupForward";
ShiftGroupViewModel.prototype.PermissionBackward = "ShiftGroupBackward";
ShiftGroupViewModel.prototype.PermissionSave = "ShiftGroupSave";
ShiftGroupViewModel.prototype.PermissionRefresh = "ShiftGroupRefresh";
ShiftGroupViewModel.prototype.PermissionDelete = "ShiftGroupDelete";
export default ShiftGroupViewModel;